module.exports = __webpack_public_path__ + "img/箭头2.c94cbb84.png";